<script setup lang="ts">
import type { InteractionType } from '@azure/msal-browser';
import Button from 'primevue/button';
import { useLogout } from '@precon-tools-suite-by-shared/vue-msal';

const props = withDefaults(
    defineProps<{
        label?: string | null;
        icon?: string | null;
        loading?: boolean;
        disabled?: boolean;
        interactionType?:
            | InteractionType.Popup
            | InteractionType.Redirect
            | null;
        redirectUri?: string | null;
    }>(),
    {
        label: 'Uitloggen',
        icon: 'pi pi-sign-out',
        interactionType: null,
        redirectUri: null,
    }
);

const {
    logout,
    loading: logoutLoading,
    disabled: logoutDisabled,
} = useLogout({
    interactionType: () => props.interactionType,
    postLogoutRedirectUri: () => props.redirectUri,
});
</script>

<template>
    <Button
        :label="props.label ?? undefined"
        :icon="props.icon ?? undefined"
        :loading="logoutLoading || props.loading"
        :disabled="logoutDisabled || props.disabled"
        v-bind="$attrs"
        @click="logout()"
    />
</template>
